function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg040Guatemala(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#338AF3"
    },
    width: 170.663,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.337,
    style: {
      fill: "#338AF3"
    },
    width: 170.663,
    height: 512
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ACABB1"
    },
    points: "304.083,286.741 272.971,255.629 302.586,226.013 301.244,210.372 292.766,201.892   256,238.658 219.234,201.892 210.756,210.372 209.414,226.013 239.029,255.629 207.917,286.741 224.887,303.712 256,272.6   287.113,303.712 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M301.255,210.373l-16.971,16.971c7.238,7.239,11.716,17.239,11.716,28.285  c0,22.092-17.909,40.001-40.001,40.001s-40.001-17.909-40.001-40.001c0-11.045,4.478-21.045,11.716-28.285l-16.971-16.971  C199.162,221.954,192,237.954,192,255.628c0,35.346,28.654,64,64,64s64-28.654,64-64C320,237.954,312.836,221.954,301.255,210.373z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg040Guatemala);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHJlY3Qgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSIxNzAuNjYzIiBoZWlnaHQ9IjUxMiIvPgoJPHJlY3QgeD0iMzQxLjMzNyIgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSIxNzAuNjYzIiBoZWlnaHQ9IjUxMiIvPgo8L2c+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNBQ0FCQjE7IiBwb2ludHM9IjMwNC4wODMsMjg2Ljc0MSAyNzIuOTcxLDI1NS42MjkgMzAyLjU4NiwyMjYuMDEzIDMwMS4yNDQsMjEwLjM3MiAyOTIuNzY2LDIwMS44OTIgICAyNTYsMjM4LjY1OCAyMTkuMjM0LDIwMS44OTIgMjEwLjc1NiwyMTAuMzcyIDIwOS40MTQsMjI2LjAxMyAyMzkuMDI5LDI1NS42MjkgMjA3LjkxNywyODYuNzQxIDIyNC44ODcsMzAzLjcxMiAyNTYsMjcyLjYgICAyODcuMTEzLDMwMy43MTIgIi8+CjxwYXRoIHN0eWxlPSJmaWxsOiM2REE1NDQ7IiBkPSJNMzAxLjI1NSwyMTAuMzczbC0xNi45NzEsMTYuOTcxYzcuMjM4LDcuMjM5LDExLjcxNiwxNy4yMzksMTEuNzE2LDI4LjI4NSAgYzAsMjIuMDkyLTE3LjkwOSw0MC4wMDEtNDAuMDAxLDQwLjAwMXMtNDAuMDAxLTE3LjkwOS00MC4wMDEtNDAuMDAxYzAtMTEuMDQ1LDQuNDc4LTIxLjA0NSwxMS43MTYtMjguMjg1bC0xNi45NzEtMTYuOTcxICBDMTk5LjE2MiwyMjEuOTU0LDE5MiwyMzcuOTU0LDE5MiwyNTUuNjI4YzAsMzUuMzQ2LDI4LjY1NCw2NCw2NCw2NHM2NC0yOC42NTQsNjQtNjRDMzIwLDIzNy45NTQsMzEyLjgzNiwyMjEuOTU0LDMwMS4yNTUsMjEwLjM3M3oiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };